import { createContext } from 'react';

import { TenantsProviderState } from 'features/tenants/providers/tenants-provider/state/tenants-provider-state';

const TenantsProviderContext = createContext<TenantsProviderState>({} as TenantsProviderState);

export default TenantsProviderContext;
